(() => {
  'use strict';
  if (window.txCareAddonsInitialized) return;
  window.txCareAddonsInitialized = true;
  const drawer = document.querySelector('#cart-drawer');
  const box = drawer?.querySelector('[data-cart-care]');
  if (!drawer || !box) return;

  let products = {};
  try { products = JSON.parse(box.querySelector('[data-tx-care-products]')?.textContent || '{}'); } catch {}
  window.txCareProducts = products;
  const elements = selector => [...drawer.querySelectorAll(selector)];
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const format = (value, cart) => new Intl.NumberFormat('en-US', {style:'currency', currency:cart?.currency || window.Shopify?.currency?.active || 'USD'}).format(value / 100);
  const feedback = message => { const node = box.querySelector('[data-care-feedback]'); if (node) node.textContent = message || ''; };
  const hasProduct = (cart, kind) => {
    const productId = products[kind]?.productId;
    const variantId = products[kind]?.variantId;
    return !!cart?.items?.some(item =>
      (productId && String(item.product_id) === String(productId)) ||
      (variantId && String(item.variant_id) === String(variantId))
    );
  };

  function sync(cart = window.txCareCart) {
    if (!cart) return;
    const duo = hasProduct(cart, 'duo');
    const gel = duo || hasProduct(cart, 'gel');
    const serum = duo || hasProduct(cart, 'serum');
    box.hidden = !cart.item_count;
    elements('[data-care-toggle]').forEach(input => {
      input.checked = input.dataset.careToggle === 'gel' ? gel : serum;
      input.closest('.tx-addon-row')?.classList.toggle('is-selected', input.checked);
    });
    elements('[data-care-option="duo"]').forEach(button => {
      button.classList.toggle('is-selected', duo);
      button.setAttribute('aria-pressed', String(duo));
    });
    const rows = (cart.items || []).map(item => {
      const title = String(item.product_title || '').replace(/LumaLean/gi, 'TENSIXTY').replace(/Tensixty/g, 'TENSIXTY');
      const quantity = item.quantity > 1 ? ` × ${item.quantity}` : '';
      return `<div><span>${escape(title + quantity)}</span><span>${format(item.final_line_price, cart)}</span></div>`;
    });
    document.querySelectorAll('[data-care-order-lines]').forEach(node => { node.innerHTML = rows.join(''); });
  }

  function request(kind) {
    const product = products[kind];
    if (kind !== 'none' && (!product?.variantId || !product.available)) {
      feedback('This care item is currently unavailable.');
      sync();
      return;
    }
    feedback('');
    if (typeof window.txCareUpdate !== 'function') {
      feedback('We could not update your bag. Please refresh and try again.');
      sync();
      return;
    }
    window.txCareUpdate(kind);
  }

  document.addEventListener('change', event => {
    if (!event.target.matches('[data-care-toggle]') || !box.contains(event.target)) return;
    const gel = box.querySelector('[data-care-toggle="gel"]')?.checked;
    const serum = box.querySelector('[data-care-toggle="serum"]')?.checked;
    request(gel && serum ? 'duo' : gel ? 'gel' : serum ? 'serum' : 'none');
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-care-option="duo"]');
    if (!button || !box.contains(button)) return;
    request(button.getAttribute('aria-pressed') === 'true' ? 'none' : 'duo');
  });
  document.addEventListener('tx:cart-rendered', event => { feedback(''); sync(event.detail); });
  document.addEventListener('tx:care:error', event => { feedback(event.detail?.message || 'We could not update your bag.'); sync(event.detail?.cart); });
  sync();
})();
